import React from 'react';
import SiteHeader from './SiteHeader';
import HomeHero from './HomeHero';
import HomeFeatures from './HomeFeatures';
import HomeNews from './HomeNews';
import Contact from './Contact';
import Footer from './Footer';
import NoticePopup from './NoticePopup';

// ★ 이 이미지는 시안 단계의 AI 생성물이고 실제 제품이 아니다(I-20).
//   2026-09-30 대표 판단으로 이 상태로 오픈했다. V4 센서·중계기 실물 촬영본이
//   준비되면 이 파일만 교체하면 된다(경로 고정).
const HERO_IMG = process.env.PUBLIC_URL + '/images/hero.jpg';

function Home() {
  return (
    <>
      <SiteHeader />
      <HomeHero heroImage={HERO_IMG} />
      <HomeFeatures />
      <HomeNews />
      <div id="contact">
        <Contact />
      </div>
      <Footer />
      {/* 공지 팝업 — 옛 메인(MainSite)에만 있던 것을 새 메인으로 옮겼다 */}
      <NoticePopup />
    </>
  );
}

export default Home;
